export const Capitalize = (s, type) => {
  if (!s) return ' ';
  const arr = s.split(' ');
  for (let i = 0; i < arr.length; i++) {
    if (omittedWords.includes(arr[i])) continue;
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
    arr[i] = type && type === 'name' ? arr[i].replace(/(?:'|-)[a-z]/g, (match) => match.toUpperCase()) : arr[i];
  }
  return arr.join(' ');
};

const omittedWords = ['PO'];
